import React, { Component } from 'react';

export default class Contact extends Component {
  render() {
  	var border0 = {
  		border: 0
  	};

    return (

      	<div className="container">
			<div className="row pt50 pb50">
				
				<div className="col-md-6 col-sm-6">
					<h2 className="uppercase pb20"><i className="fa fa-address-book-o"></i> Contact</h2>
					<p className="bold fs16"><i className="fa fa-qrcode"></i> Scan for Send Email to Me.</p>
					<img alt="" src="https://chart.googleapis.com/chart?cht=qr&chl=MATMSG%3ATO%3Aandrideng%40gmail.com%3BSUB%3ASend%20Email%20to%20AndriDeng%3BBODY%3AThank%20for%20send%20me%20Email.%0ABest%20Regards%2C%0AAndri%20Deng%3B%3B&chs=180x180&choe=UTF-8&chld=L|2" />
					<p className="pt10"><b>Note:</b></p>
					<p>
						<i className="fa fa-caret-right"></i> For iOS use <b>Quick Scan</b> free apps. <a href="https://itunes.apple.com/us/app/quick-scan-qr-code-reader/id483336864?mt=8" target="_blank" rel="noopener noreferrer">Download Link</a> <br/>
		            
					</p>
					<p>
						<i className="fa fa-caret-right"></i> For Android use <b>QR &amp; Barcode Scanner</b> free aps. <a href="https://play.google.com/store/apps/details?id=com.gamma.scan" target="_blank" rel="noopener noreferrer">Download Link</a>
					</p>
				</div>
				<div className="col-md-6 col-sm-6">
					<h2 className="uppercase pb20"><i className="fa fa-map-marker"></i> Location</h2>

					<iframe title="Google Map" alt="" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d641.3937983611231!2d106.86402125645866!3d-6.140378099608096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f582126847b7%3A0xcad4c1b422dfe025!2sJl.+Agung+Permai+32+No.15%2C+Sunter+Agung%2C+Tj.+Priok%2C+Kota+Jkt+Utara%2C+Daerah+Khusus+Ibukota+Jakarta+14350!5e0!3m2!1sen!2sid!4v1476868073739" width="100%" height="260" style={border0}></iframe>
				</div>
			</div>
		</div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/components/Contact.js